export default function PPDButton() {
  return (
    <div>
      <button
        name="ppd_button"
        className="text-white bg-black bg-opacity-0 h-10 px-5 rounded-lg border border-white transition duration-300 ease-in-out hover:bg-white hover:text-black hover:border-transparent hover:shadow-outline"
      >
        <a href="https://ppd.polarfi.io/">Visit Now</a>
      </button>
    </div>
  );
}
